import { useEffect, useState } from 'react';

/**
 * True once the user has scrolled past the hero frames section (#hero) — beyond
 * its scrub range (height − one viewport), the point at which the next section
 * appears. Returns true when there's no #hero on the page (e.g. sub-pages).
 *
 * Shared so bottom-anchored UI (the floating dock, the cookie banner) reveals at
 * the same point instead of sitting over the hero.
 */
export function usePastHero(): boolean {
  const [pastHero, setPastHero] = useState(false);

  useEffect(() => {
    const hero = document.getElementById('hero');
    const onScroll = () => {
      if (!hero) {
        setPastHero(true);
        return;
      }
      const threshold = hero.offsetHeight - window.innerHeight;
      setPastHero(window.scrollY > threshold);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  return pastHero;
}
